// Port of api/fuel/app/classes/insights/ratings/plays.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'plays',
    priority: 1,
    default_: true,
    requires: [],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_ratings()) return {}

        var metrics = []

        for (var i = 1; i <= 10; i++) {
            metrics.push({
                rating: i,
                games: 0,
                plays: 0,
                avg: 0
            })
        }

        var ratings = Util.query('\
            SELECT \
                r.game_id AS g, \
                AVG(r.rating_value) AS r \
            FROM \
                rating r \
            WHERE \
                r.user_id IN (' + Util.in(userIndex) + ') \
            GROUP BY \
                r.game_id \
        ', null, 'g')

        var ratingGameIds = Object.keys(ratings).map(function(k) { return ratings[k].g })

        var plays = Util.query('\
            SELECT \
                p.game_id AS g, \
                SUM(p.play_count) AS p \
            FROM \
                play p \
            WHERE \
                p.user_id IN (' + Util.in(userIndex) + ') \
                AND \
                p.game_id IN (' + Util.in(ratingGameIds) + ') \
            GROUP BY \
                p.game_id \
        ', null, 'g')

        var rkeys = Object.keys(ratings)
        for (var ri = 0; ri < rkeys.length; ri++) {
            var rating = ratings[rkeys[ri]]

            var ratingValue = Math.floor(parseFloat(rating.r)) - 1

            if (ratingValue >= 0 && ratingValue < 10) {
                metrics[ratingValue].games++
                metrics[ratingValue].plays += (plays[rating.g]) ? parseInt(plays[rating.g].p, 10) : 0
                metrics[ratingValue].avg = Math.round((metrics[ratingValue].plays / metrics[ratingValue].games) * 100) / 100
            }
        }

        return {
            plays: metrics
        }

    }
})
